export default "__VITE_ASSET__34365fb8__"